<app-header [navbarBrandRouterLink]="['/']" [fixed]="true"
    [navbarBrandFull]="{src: 'assets/img/logo.svg', width: 89, height: 35, alt: 'Logo'}" [sidebarToggler]="'lg'"
    [asideMenuToggler]="'lg'">
    <ul class="nav navbar-nav ml-auto">
        <li class="nav-item dropdown" dropdown placement="bottom right">
            <a class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"
                dropdownToggle (click)="false">
                <img src="assets/img/user-vector.png" class="img-avatar" alt="admin@bootstrapmaster.com" />
            </a>
            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
                <div class="dropdown-header text-center"><strong>Settings</strong></div>
                <!-- <a class="dropdown-item" routerLink="/profile"><i class="fa fa-user"></i> Profile</a> -->
                <a class="dropdown-item" routerLink="/profile"><i class="fa fa-user"></i> Profile</a>
                <div class="divider"></div>
                <button class="dropdown-item" (click)="authService.adminLogout()"><i class="fa fa-lock"></i>
                    Logout</button>
            </div>
        </li>
    </ul>
</app-header>

<div class="app-body">
    <app-sidebar #appSidebar [fixed]="true" [display]="'lg'" [minimized]="sidebarMinimized"
        (minimizedChange)="toggleMinimize($event)">
        <app-sidebar-nav [navItems]="navItems" [perfectScrollbar] [disabled]="appSidebar.minimized"></app-sidebar-nav>
        <app-sidebar-minimizer></app-sidebar-minimizer>
    </app-sidebar>


    <main class="main">
        <app-dashboard-breadcrumb [PageTitle]="PageTitle" [PageBreadcrumb]="PageBreadcrumb"></app-dashboard-breadcrumb>

        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>
    </main>
</div>

<app-footer>
    <span><a href="#!">{{ Global.APP_NAME }}</a> &copy; {{Global.CURRENT_YEAR}}. All Rights Reserved</span>
    <span class="ml-auto">Developed by <a href="https://ivaninfotech.com" target="_blank">Ivan Infotech</a></span>
</app-footer>